import { useCallback, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import ButtonCooldown from "../../../components/ButtonCooldown/ButtonCooldown.jsx";
import { useDispatch, useSelector } from "react-redux";
import { forgotPasswordAction } from "../authActions";
import { getPasswordForgotErrorSelector, getPasswordForgotSentSelector } from "../authSelectors.js";
import RouterPaths from "../../../app/routePaths";

function Forgot() {
    const dispatch = useDispatch();

    const [email, setEmail] = useState('');
    const passwordForgotSent = useSelector(getPasswordForgotSentSelector);
    const passwordForgotError = useSelector(getPasswordForgotErrorSelector);

    const submitHandler = useCallback((e) => {
        e.preventDefault();
        const email = e.target.querySelector('[name=email]').value;
        dispatch(forgotPasswordAction({ email }));
        setEmail(email);
    }, [dispatch]);

    const resendClickHandler = useCallback((e) => {
        e.preventDefault();
        dispatch(forgotPasswordAction({ email }));
    }, [email, dispatch]);

    return <>
        {
            passwordForgotSent ? <>
                <Form.Group className="mb-5 mt-2">
                    <h4 className="text-center">Check email</h4>
                </Form.Group>
                <p className="mb-4">We've sent you a link — follow it to restore the password. Didn’t receive the email?
                    Click to resend</p>
                <div className="d-flex flex-column mb-2">
                    <ButtonCooldown successMessage={'We\'ve sent you a link'}
                                    cooldownMessage={'Resend link in'}
                                    className="mb-4"
                                    onClick={resendClickHandler}>
                        Resend link
                    </ButtonCooldown>
                    <Button variant={'secondary'} as={Link} to={RouterPaths.login} type="button">
                        Back to Log in
                    </Button>
                </div>
            </> : <>
                <Form.Group className="mb-4 mt-2">
                    <h4 className="text-center">Reset password</h4>
                </Form.Group>
                <p>Enter the email you used to create the account</p>
                <Form onSubmit={submitHandler}>
                    <Form.Group className={'mb-4'}>
                        <Form.Control name="email" type="email"
                                      placeholder={'Email'}
                                      required/>
                    </Form.Group>

                    {
                        !!passwordForgotError && <>
                            <p className={'text-danger'}>
                                {passwordForgotError}
                            </p>
                        </>
                    }

                    <div className="d-grid mb-2">
                        <Button variant={'primary'} type="submit" className="mb-4">
                            Reset password
                        </Button>
                        <Button variant={'secondary'} as={Link} to={RouterPaths.login} type="button">
                            Back to Log in
                        </Button>
                    </div>
                </Form>
            </>
        }
    </>
}

export default Forgot;
